'use client';

import { IcCloseCircle, IconButton, IcSearch, TextField } from '@musinsa/mds';
import { useCallback } from 'react';
import { twMerge } from 'tailwind-merge';
import { useDebouncedInput } from '../../common/hooks';

interface SearchProductInputProps {
  className?: string;
  placeholder?: string;
  keyword: string;
  onChangeKeyword: (keyword: string) => void;
}

export function SearchProductInput({
  className,
  placeholder,
  keyword,
  onChangeKeyword,
}: SearchProductInputProps) {
  // 디바운스된 입력 훅 사용
  const [localKeyword, handleKeywordChange, syncExternalValue] = useDebouncedInput(
    keyword,
    onChangeKeyword,
    300,
  );

  const onClearKeyword = useCallback(() => {
    syncExternalValue('');
    onChangeKeyword('');
  }, [onChangeKeyword, syncExternalValue]);

  return (
    <div className={twMerge(className, 'px-4 py-3')}>
      <div className="inline-flex relative w-full">
        <TextField
          value={localKeyword}
          onChange={(e) => handleKeywordChange(e.target.value)}
          placeholder={placeholder}
          name="keyword"
          className="w-full bg-white pr-12"
        />
        {keyword.length > 0 && (
          <IconButton className="absolute right-32 top-2" size="size20x20" onClick={onClearKeyword}>
            <IcCloseCircle fillColor="gray-400" />
          </IconButton>
        )}
        <IconButton className="absolute right-8 top-8" size="size20x20">
          <IcSearch strokeColor="gray-500" />
        </IconButton>
      </div>
    </div>
  );
}
